import React, { Component } from 'react';
import Slider from 'react-slick';
import Constants from '../../Constants';
import Dom from '../../utils/Dom';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import GeneralCarousel from './../general-carousel/GeneralCarousel';
import { Row, Col, Container, Card } from 'reactstrap';
import { LargeBusiness, moduleMargins, htmlWidget } from '../../Constants';

class EirFeaturesBenefits extends Component {
  constructor(props) {
    super(props);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);
    this.state = {
      printBG: this.props.image,
      isBusinessFormat: Boolean(this.props.businessFormatForDTOnly),
    };
    this.triggerOnResize = this.triggerOnResize.bind(this);
  }
  componentWillMount() {
    this.setState({
      fAndBList: this.props
    })
  }

  getCarouselImages() {
    let images = []

    this.props.tiles.map(tile => {
      let o = []
      o.src = tile.image.path
      images.push(o)
      //images.push(tile.image.path)
    });

    return images;

  }

  // Need to think of a more elegant way to do this
  // Doing it for now, to try and keep GeneralCarousel "general"
  getCarouselText() {
    let texts = []

    this.props.tiles.map(tile => {
      let o = []
      o = tile.text
      texts.push(o)
      //images.push(tile.image.path)
    });

    return texts;

  }

  getCarouselTextHeading() {
    let textHeadings = []

    this.props.tiles.map(tile => {
      let o = []
      o = tile.title
      textHeadings.push(o)
      //images.push(tile.image.path)
    });

    return textHeadings;

  }

  //strips off the html tags received from openCMS and prints only the cotent
  renderContent = (content) => {
    return { __html: content };
  }

  // called on resize - DT, orientation change in devices
  triggerOnResize() {
    if ($(".slick-dots li").length > 0) $(".slick-dots").find("li.slick-active :button").click() //fix for PWD- 133 portrait to landscape mode -
    //below is to hide the arrows for mobile devices
    if (isMobile || isTablet) {
      $(".slick-arrow").each(function () {
        $(this).css({ "display": "none !important", "visibility": "hidden" });
      })
    }
  }

  componentDidMount() {
    // (this.props.businessFormatForDTOnly === "true" && (isMobile || isTablet)) ? $("#fab-container-" + this.props.BenefitsOccurence).addClass("d-none") : "";
    this.triggerOnResize();
    //to make equal height for the start of the content for each image
    let getSubtitle = $("#fab-container-" + this.props.BenefitsOccurence + " .fb-content-ctr").find(".eir-item-title");
    if ($(window).width() > 414) {
      $(getSubtitle).each(function (ind) {
        var firstItem, secondItem;
        var prev = ind - 1;
        if (ind % 2 != 0 && prev >= 0) {
          firstItem = parseInt(getSubtitle[prev].clientHeight);
          secondItem = parseInt(getSubtitle[ind].clientHeight);
          var maxHeight = Math.max(firstItem, secondItem);
          getSubtitle[prev].style.height = maxHeight + "px";
          getSubtitle[ind].style.height = maxHeight + "px";
        }
        // subtitleHeightList.push(parseInt(getSubtitle[ind].clientHeight))
      })
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.triggerOnResize);
  }

  getBackgroundImage() {
    if (isMobile && !isTablet) {
      return this.props.imageMobile.path
    }
    return this.props.image.path
  }

  render() {
    let [marginDesktop, marginMobile] = moduleMargins(this.props.MarginDT, this.props.MarginMobile);
    const classes= {Container: LargeBusiness.isLBSite ? " fab-container fab-lb-container" : " fab-container",
                          margin: isMobile ? marginMobile : marginDesktop};

    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 2,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {

            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 0
          }
        },
        {
          breakpoint: 868,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 0
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,

          }
        }
      ],
      //Hide the arrows for mobile devices
      afterChange: function () {
        if (isMobile || isTablet) {
          $(".slick-arrow").each(function () {
            $(this).css("visibility", "hidden");
          })
        }
        else {
          $(".slick-arrow").each(function () {
            $(this).css("visibility", "visible !important");
          })

        }
      }
    };

    window.addEventListener("resize", this.triggerOnResize);
    const featureBenefitList = this.state.fAndBList;
    return (
      
      <div className={classes.Container + classes.margin} id={"fab-container-" + this.props.BenefitsOccurence}>
        {this.props.businessFormatForDTOnly !== "true" &&
          <div className="features-and-benefits-main"
            style={{
              backgroundImage: "url(" + this.getBackgroundImage() + ")",
              // backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className="forCarousalInFnB ">
              {/* </div> {(isMobile && !isTablet) ?  */}
              <div>
                <div className="general-carousel-container d-md-none">
                  <div className={' col-md-12 text-center ' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}>
                    <h1 className="eir-title">{featureBenefitList.title}</h1>
                  </div>
                  <div className={' col-md-12 text-center ' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}>
                    <GeneralCarousel
                      items={this.getCarouselImages()}
                      textHeading={this.getCarouselTextHeading()}
                      optionalText={this.getCarouselText()}>
                    </GeneralCarousel>
                  </div>
                </div>
              </div>
              <div className="desktop-tab-only">
                <div className="feature-benefits-contianer container " >
                  <div className="">

                    <div className={' col-md-12 text-center ' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}>
                      <h1 className="eir-title">{featureBenefitList.title}</h1>
                    </div>

                    <Slider {...settings} className="eir-carousel">
                      {
                        featureBenefitList.tiles.map((object, i) =>

                          <div className="fb-item h-line col" key={i}>
                            <div className="fb-image-ctr">
                              <img className="fb-image"
                                src={object.image.path} alt={(object.imageAlt != undefined && object.imageAlt != '') ? object.imageAlt : ''}
                                title={(object.cta != undefined && object.cta.title != '') ? object.cta.title : ''}
                              />
                            </div>
                            <div className="fb-content-ctr">
                              <div className={(this.props.theme) ? ' eir-theme-' + this.props.theme : ' eir-theme-default'}><h2 className="eir-title eir-item-title">{object.title}</h2></div>
                              <div className={' eir-text '+htmlWidget  + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}><p className="eir-text" dangerouslySetInnerHTML={this.renderContent(object.text)}></p></div>
                            </div>
                          </div>

                        )
                      }
                    </Slider>
                  </div>
                </div>
              </div>

            </div>
          </div>
        }

        {/* FOR BUSINESS SITE LAYOUT -- ONLY DESKTOP VIEW AND MOBILE VIEW HAS TO BE HIDDEN - EIR-525 */}
        {
          (this.props.businessFormatForDTOnly == "true" && !isMobileOnly) &&
          <div className={"business-fab-" + this.props.businessFormatForDTOnly}>
            <div className="features-and-benefits-main"
              style={{
                backgroundImage: "url(" + this.getBackgroundImage() + ")",
                // backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
              }}
            >
              <div className="forCarousalInFnB ">
                {/* </div> {(isMobile && !isTablet) ?  */}
                <div>
                  <div className="general-carousel-container d-md-none">
                    <div className={' col-md-12 text-center ' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}>
                      <h2 className="eir-title">{featureBenefitList.title}</h2>
                    </div>
                    <div className={' col-md-12 text-center ' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}>
                      {/* <GeneralCarousel
                          items={this.getCarouselImages()}
                          textHeading={this.getCarouselTextHeading()}
                          optionalText={this.getCarouselText()}>
                        </GeneralCarousel> */}
                    </div>
                  </div>
                </div>
                <div className="desktop-tab-only">
                  <div className="feature-benefits-contianer container " >
                    <div className="">

                      <div className={' col-md-12 text-center ' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}>
                        <h2 className="eir-title fab-container-title">{featureBenefitList.title}</h2>
                      </div>

                      {/* <Slider {...settings} className="eir-carousel"> */}
                      <Row className="fab-row">
                        {
                          featureBenefitList.tiles.map((object, i) =>
                            <Col className="col-6" id={i} key={i}>
                              <div className="fb-item h-line col" key={i}>
                                <div className="fb-image-ctr">
                                  <img className="fb-image"
                                    src={object.image.path} alt={(object.imageAlt != undefined && object.imageAlt != '') ? object.imageAlt : ''}
                                    title={(object.cta != undefined && object.cta.title != '') ? object.cta.title : ''}
                                  />
                                </div>
                                <div className="fb-content-ctr">
                                  {object.title.length > 0 &&
                                    <div className={(this.props.theme) ? ' eir-theme-' + this.props.theme : ' eir-theme-default'}><h2 className="eir-title eir-item-title">{object.title}</h2></div>
                                  }
                                  {object.text.length > 0 &&
                                    <div className={' eir-text ' + htmlWidget + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}><p className="eir-text" dangerouslySetInnerHTML={this.renderContent(object.text)}></p></div>
                                  }
                                </div>
                              </div>
                            </Col>
                          )
                        }
                        {/* </Slider> */}

                      </Row>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        }
      </div >


    )
  }
}

export default EirFeaturesBenefits;


